export default __webpack_public_path__ + "static/media/Shedu of Arcing Skies.c28a664d.jpg";